import { render, staticRenderFns } from "./ItemEdit.vue?vue&type=template&id=778d1d3e&scoped=true"
import script from "./ItemEdit.vue?vue&type=script&lang=js"
export * from "./ItemEdit.vue?vue&type=script&lang=js"
import style0 from "./ItemEdit.vue?vue&type=style&index=0&id=778d1d3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778d1d3e",
  null
  
)

export default component.exports